// https://scotch.io/tutorials/handling-authentication-in-vue-using-vuex
import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/_store";
// Adds a loading bar at the top during page loads.
import NProgress from "nprogress/nprogress";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",

  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [
    {
      path: "/",
      name: "home",
      meta: {
        beforeResolve(routeTo, routeFrom, next) {
          if (store.getters["authentication/loggedIn"]) {
            next({ name: "finder" });
          } else {
            next({ name: "login" });
          }
        }
      }
    },
    {
      path: "/login/",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "@/views/login.vue"),
      meta: {
        beforeResolve(routeTo, routeFrom, next) {
          if (store.getters["authentication/loggedIn"]) {
            next({ name: "finder" });
          } else {
            next();
          }
        }
      }
    },
    {
      path: "/password-lost",
      name: "password-lost",
      component: () =>
        import(/* webpackChunkName: "password-lost" */ "@/views/password-lost.vue")
    },
    {
      path: "/register/",
      name: "register",
      component: () =>
        import(/* webpackChunkName: "register" */ "@/views/register.vue"),
      children: [
        {
          path: ":type",
          meta: {
            beforeResolve(routeTo, routeFrom, next) {
              if (!["applicant", "affiliate"].includes(routeTo.params.type)) {
                next({ path: "/register/" });
              } else if (
                routeTo.params.type == "applicant" &&
                routeTo.params.entity != "person"
              ) {
                next({ path: "/register/applicant/person/" });
              }
              next();
            }
          },
          children: [
            {
              path: ":entity"
            }
          ]
        }
      ]
    },
    // {
    //   path: "/register/",
    //   name: "register",
    //   component: () =>
    //     import(/* webpackChunkName: "register" */ "@/views/registerold.vue"),
    //   children: [
    //     {
    //       path: ":type",
    //       meta: {
    //         beforeResolve(routeTo, routeFrom, next) {
    //           if (!["applicant", "affiliate"].includes(routeTo.params.type)) {
    //             next({ path: "/register/" });
    //           } else if (routeTo.params.step == undefined) {
    //             next({
    //               path: "/register/" + routeTo.params.type + "/step/1/"
    //             });
    //           }
    //           next();
    //         }
    //       },
    //       children: [
    //         {
    //           path: "step/:step"
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   path: "/register/applicant/",
    //   name: "register-applicant",
    //   component: () =>
    //     import(/* webpackChunkName: "register-applicant" */ "@/views/register-applicant.vue")
    // },
    // {
    //   path: "/register/affiliate/",
    //   name: "register-affiliate",
    //   component: () =>
    //     import(/* webpackChunkName: "register-affiliate" */ "@/views/register-affiliate.vue")
    // },
    // {
    //   path: "/register/:type/",
    //   name: "register",
    //   component: () =>
    //     import(/* webpackChunkName: "register" */ "@/views/register-type.vue"),
    //   meta: {
    //     beforeResolve(routeTo, routeFrom, next) {
    //       if (!["applicant", "affiliate"].includes(routeTo.params.type)) {
    //         next({ path: "/register/" });
    //       }
    //       next();
    //     }
    //   }
    // },
    // {
    //   path: "/register/:type/:entity/",
    //   name: "register",
    //   component: () =>
    //     import(/* webpackChunkName: "register" */ "@/views/registernew.vue"),
    //   meta: {
    //     beforeResolve(routeTo, routeFrom, next) {
    //       if (!["applicant", "affiliate"].includes(routeTo.params.type)) {
    //         next({ path: "/register/" });
    //       }
    //       if (!["person", "business"].includes(routeTo.params.entity)) {
    //         next({ path: `/register/${routeTo.params.type}/` });
    //       }
    //       next();
    //     }
    //   }
    // },
    {
      path: "/publish/",
      name: "publish",
      component: () =>
        import(/* webpackChunkName: "publish" */ "@/views/applications-publisher.vue"),
      meta: {
        beforeResolve(routeTo, routeFrom, next) {
          if (!store.getters["authentication/canPublishApplications"]) {
            next({ name: "finder" });
          } else {
            next();
          }
        },
        layout: "dashboard"
      }
    },
    {
      path: "/finder",
      name: "finder",
      // props: route => ({ propQuery: route.query }),
      component: () =>
        import(/* webpackChunkName: "finder" */ "@/views/applications-finder.vue"),
      meta: {
        layout: "dashboard"
      }
    },
    {
      path: "/application/:id/",
      name: "single-application",
      component: () =>
        import(/* webpackChunkName: "single-application" */ "@/views/single-application.vue"),
      meta: {
        layout: "dashboard"
      }
    },
    {
      path: "/account/",
      name: "account",
      // route level code-splitting
      // this generates a separate chunk (account.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "account" */ "@/views/account.vue"),
      meta: {
        layout: "dashboard"
      }
    },
    {
      path: "/tokens/",
      name: "tokens",
      component: () =>
        import(/* webpackChunkName: "tokens" */ "@/views/tokens.vue"),
      meta: {
        refresh: true,
        layout: "dashboard"
      }
    },
    {
      path: "/profile/:id/",
      name: "profile",
      component: () =>
        import(/* webpackChunkName: "single-application" */ "@/views/single-profile.vue"),
      meta: {
        layout: "dashboard"
      }
    },
    {
      path: "/settings/",
      name: "settings",
      component: () =>
        import(/* webpackChunkName: "settings" */ "@/views/settings.vue"),
      meta: {
        refresh: true,
        layout: "dashboard"
      }
    },
    {
      path: "/test/",
      name: "test",
      component: () =>
        import(/* webpackChunkName: "test" */ "@/views/test.vue"),
      meta: {
        refresh: true,
        layout: "dashboard"
      }
    }
  ]
});

router.beforeEach((routeTo, routeFrom, next) => {
  // If this isn't an initial page load...
  if (routeFrom.name !== null) {
    // Start the route progress bar.
    NProgress.start();
  }

  // redirect to login page if not logged in and trying to access a restricted page
  // const publicPages = ["home", "login", "password-lost", "register", "register-steps"];
  // const authRequired = !publicPages.includes(routeTo.name);
  const authRequired = routeTo.meta.layout == "dashboard" ? true : false;

  // const loggedIn = localStorage.getItem("user");
  // eslint-disable-next-line
  // const loggedIn = typeof sappObj.user != "undefined" ? sappObj.user : false;
  const loggedIn = !!store.state.authentication.user;

  if (authRequired && !loggedIn) {
    return next("/login/");
  }

  if (!authRequired && loggedIn) {
    return next("/finder/");
  }

  // console.log(routeTo);
  // console.log("from:", from);
  // console.log("to:", to);

  // if (routeFrom.meta.refresh) {
  //   window.location.href = routeTo.path;
  //   return;
  // }

  // // if (routeTo.meta.refresh && (routeFrom.name !== routeTo.name && routeFrom.name !== null)) {
  // if (routeTo.meta.refresh && routeFrom.name !== null) {
  //   window.location.href = routeTo.path;
  //   return;
  // }

  next();
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              if (routeFrom.name === args[0].name) {
                // Complete the animation of the route progress bar.
                NProgress.done();
              }
              // Complete the redirect.
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }

  // If we reach this point, continue resolving the route.
  next();
});

// When each route is finished evaluating...
router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
